var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9971 4C11.4448 4 10.9971 4.44772 10.9971 5 10.9971 5.55228 11.4448 6 11.9971 6H16.9994C17.5517 6 17.9994 6.44771 17.9994 7V17C17.9994 17.5523 17.5517 18 16.9994 18H11.9971C11.4448 18 10.9971 18.4477 10.9971 19 10.9971 19.5523 11.4448 20 11.9971 20H16.9994C18.6562 20 19.9994 18.6569 19.9994 17V7C19.9994 5.34315 18.6563 4 16.9994 4H11.9971zM9.74352 7.33577C10.1104 7.74861 10.0731 8.38068 9.66024 8.74753L7.12537 11H13.9975C14.5498 11 14.9975 11.4477 14.9975 12 14.9975 12.5523 14.5498 13 13.9975 13H7.12537L9.66024 15.2525C10.0731 15.6193 10.1104 16.2514 9.74352 16.6643 9.37667 17.0771 8.7446 17.1144 8.33176 16.7475L4.67152 13.495C3.77616 12.6994 3.77616 11.3006 4.67152 10.505L8.33176 7.25249C8.7446 6.88564 9.37667 6.92293 9.74352 7.33577z",
    fill: "url(#paint0_linear_6580_13544)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6580_13544",
    x1: -5.19965,
    y1: 3.66521,
    x2: -5.19965,
    y2: 17.1961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016dff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8ca45954.svg";
export { ForwardRef as ReactComponent };